import { useState } from "react";
import { FormContainer } from "./FormContainer";
import { Checkbox, FieldLabel } from "@braze/beacon-core";
import { FieldProps } from "./types";

export const OptionalCheckbox = (props: FieldProps) => {
    const [checked, setChecked] = useState(false);

    return (
        <FormContainer>
            <FieldLabel label={props.name}>
                <Checkbox
                    checked={checked}
                    onChange={(e) => {
                        setChecked(!checked);
                        props.handleChange(!checked)
                    }
                    }>
                    {props.text}
                </Checkbox>
            </FieldLabel>

        </FormContainer>
    )
}